module.exports = __webpack_public_path__ + "img/vipdefault.c9fa537c.jpg";